import React, { useContext, useState, useEffect } from 'react';

import { 
    Alert,
    AlertTitle,
    Box
} from '@mui/material';

import ProjectContext from '../../contexts/ProjectContext';
import {useFetch} from '../../components/auth/useFetch';

import FdlButton from '../buttons/FdlButton'
import FormField from '../formfield/FormField';
import HelpTooltip from '../popover/HelpTooltip';


export default function CanvasForm(props) {
    const projectContext = useContext(ProjectContext);

    const { style, cameraDataStore, setCameraDataStore, intentsDataStore, display, setCurrentForm, partialFDL, fdlData, setFdlData } = props;
    const [manufacturer, setManufacturer] = useState('');
    const [camera, setCamera] = useState('');
    const [resolutionData, setResolutionData] = useState('');
    const [resolutionX, setResolutionX] = useState('');
    const [resolutionY, setResolutionY] = useState('');
    const [effectiveX, setEffectiveX] = useState('');
    const [effectiveY, setEffectiveY] = useState('');
    const [effectiveAncY, setEffectiveAncY] = useState(0);
    const [effectiveAncX, setEffectiveAncX] = useState(0);
    const [anamorphic, setAnamorphic] = useState(1);
    const [formErrorText, setFormErrorText] = useState('');
    const [subheadingExtended, setSubheadingExtended] = useState(false);
    const [subheadingExtendedButtonText, setSubheadingExtendedButtonText] = useState('Read More');
    const [blockReviewPage, setBlockReviewPage] = useState()
    const fetchWithAuth = useFetch()


    /////////////////////////////////// STYLE ///////////////////////////////////
    const containerStyle = {
        display: display,
        ...style
    };

    const finishedButtonStyle = {
        backgroundColor: 'green'
    };

    const bottomButtonContainer = {
        width: '90%',
        display: 'flex',
        justifyContent: 'space-between',
    };

    const headerStyle = {
        margin: '0',
        textAlign:'left'
    }

    const subheadingStyle = {
        color: 'grey',
        margin: '0',
        marginBottom:'20px',
        width: '90%',
        textAlign:'left'
    }

    const subheadingReadmoreStyle = {
        color: 'grey',
        margin: '0',
        display: subheadingExtended ? 'block' : 'none',
        marginTop: '20px',
        textAlign:'left'
    }

    const toggleSubheadingButtonStyle = {
        color: 'silver',
        marginBottom: '20px',
        backgroundColor: 'rgba(0,0,0,0)',
        padding: '0',
        boxShadow: 'none'
        
    }

    const sectionHeadingStyle = {
        width: '100%',
        color:'silver',
        marginBottom: '15px',
        textAlign:'left'
    }


    /////////////////////////////////// STYLE ///////////////////////////////////


    const formErrorTextStyle = {
        opacity: formErrorText? 0.7 : 0,
        width: '70%',
        marginTop: '15px'
    }
    

    const switchStyle = {
        height: '56px'
    }


    // Toggle 'Finished Adding Cameras' button if we have no FDL data input
    // and want to restrict access to the Review page
    useEffect(()=>{
        if(Object.keys(intentsDataStore) == 0 || Object.keys(cameraDataStore) == 0){
            setBlockReviewPage(true)
        }else{
            setBlockReviewPage(false)
        }
    },[intentsDataStore, cameraDataStore])

    function toggleSubheadingExtended(){
        subheadingExtended ? setSubheadingExtended(false) : setSubheadingExtended(true);
        subheadingExtended ? setSubheadingExtendedButtonText('Read More') : setSubheadingExtendedButtonText('Read Less');
    }

    // Get resolution dimension ints from database
    // Do this only when resolutionData changes
    useEffect(() => {
        // When we have a Camera Resolution set, autofill fields Resolution X and Y
        getResDimensions(resolutionData);
    }, [resolutionData]);

    // Fetch the resolution JSON data
    // Then find within it the entry that matches the name provided by resolutionData, as selected in our form
    async function getResDimensions(resolutionData) {
        if (resolutionData){
            let fetchDetails = {
                method: "POST",
                body: JSON.stringify({'resName': resolutionData}),
                headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db }
            };
            
            let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlresdetails/`, fetchDetails);
            let result = await request.json();
            setResolutionX(result['GET'][0]);
            setResolutionY(result['GET'][1]);
        }
    };

    // Section complete, prepare to move on to 
    async function finishSection(event) {
        let partialFDL = await CompilePartialFDL(cameraDataStore, intentsDataStore);
        await fetchReviewResult(partialFDL);
        setCurrentForm('review');
    };

    async function CompilePartialFDL(cameraData, intentsData) {
        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({'cameraData': cameraData, 'intentsData': intentsData}),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db }
        };

        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlcompilepartial/`, fetchDetails);
        let response = await request.json();
        return response;
    };

    async function fetchReviewResult(partialFDL) {
        let fetchDetails = {
            method: "POST",
            body: JSON.stringify(partialFDL),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db }
        };
        
        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlreview1/`, fetchDetails);
        let response = await request.text();
        setFdlData(response)
    };

    async function handleSubmit(event) {
        event.preventDefault();
        let formObject = event.currentTarget;

        const data = new FormData(event.currentTarget);
        let tempDataStore = cameraDataStore;
        let newKey = 'Error, no label entered';
        let newData = {};
        let cameraID;
        for (const entry of data.entries()) {
            if (entry != undefined) {
                // First two if statements check to see if Source Canvas ID is empty, and if so assign it the value of Camera ID as per FDL spec
                if (entry[0] === 'Camera Label') {
                    cameraID = entry[1]
                    newKey = entry[1]
                    newData[`${entry[0]}`] = entry[1]
                }
                // else if (entry[0] === 'Source Canvas ID') {
                //     if (entry[1] === '') {
                //         entry[1] = cameraID
                //     }
                // }
                else{
                    newData[`${entry[0]}`] = entry[1]
                }
            }
        };

        // TODO: Connect to backend, validate THIS part of the FDL using  backend checkswe
        // return pass or fail
        // If pass, do the below
        // If fail, display failure reason

       
        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({
                'dataType': 'canvas', 
                'data': newData,
                'allCameraData': cameraDataStore,
                'action': 'create'
            }),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db }
        };
        let response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlvalidateinputone/`, fetchDetails);
        let result = await response.json();
    
        if(result['passed'] === 'fail'){
            setFormErrorText(result['reason'])
        }
        else{
            
            setFormErrorText('')
            
            window.scrollTo({top: 0, behavior: 'smooth'});
            // FIXME: the below is using tempDataStore[] to assign values to cameraDataStore instead of using setCameraDataStore
            // This is an unsafe manipulation of the cameraDataStore state object. Let's fix this.
            tempDataStore[newKey] = newData;
            setCameraDataStore((prevState) => ({
                ...prevState
            }));

            // Reset form
            
            formObject.reset();
            setManufacturer('');
            setCamera('');
            setResolutionData('');
            setResolutionX('');
            setResolutionY('');
            setEffectiveX('');
            setEffectiveY('');
            setEffectiveAncX('');
            setEffectiveAncY('');
            setAnamorphic(1);
        }

    }

       

    function chartCenterClicked(event){
        // (full canvas - eff canvas) / 2
        setEffectiveAncX((resolutionX - effectiveX) / 2)
        setEffectiveAncY((resolutionY - effectiveY) / 2)
    }
   

    return (
        <div style={containerStyle}>
            <h2 style={headerStyle}>
                Add Canvas 
                <HelpTooltip 
                    text="The Canvas describes the region of the footage or camera sensor made available for the final framing decisions." 
                />
            </h2>
            
            <Box component='form' onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    flexWrap: 'wrap'
                }}
                autoComplete="off"
            >
                <h3 style={{...sectionHeadingStyle}}>Identifiers</h3>
                
                <FormField
                    name='Camera Label'
                    label='Canvas Label'
                    fontSize='10px'
                    units=''
                    placeholder='Example Canvas'
                    selectTypeVariant='manf'
                    toolTip="Name this canvas."
                    helperTextDefault=" "
                />
                <FormField
                    name='Camera ID'
                    label='Canvas ID'
                    fontSize='10px'
                    units=''
                    placeholder='example_canvas'
                    selectTypeVariant='manf'
                    validationType='id'
                    required
                    toolTip="Give your framing intent an ID. This must be unique within the project."
                    helperTextDefault=" "
                />
                <FormField
                    name='Source Canvas ID'
                    label='Source Canvas ID'
                    fontSize='10px'
                    units=''
                    placeholder='a_different_canvas'
                    selectTypeVariant='manf'
                    validationType='id'
                    toolTip="If this canvas derives from an existing canvas, record the ID of that canvas here. 
                            The source canvas should also be recorded in a seperate entry within this FDL."
                    helperTextDefault=" "
                
                />
                <h3 style={sectionHeadingStyle}>
                    Canvas Resolution
                    <HelpTooltip 
                        text="Set the resolution for your canvas. Select a camera and resolution from our database, or enter resolution details manually." 
                    />
                </h3>
                
                <FormField
                    name='Camera Manufacturer'
                    value={manufacturer}
                    updateParentStateRecord={setManufacturer}
                    label='Camera Manufacturer'
                    fontSize='10px'
                    units=''
                    type='select'
                    selectTypeVariant='manf'
                    defaultValue={manufacturer}
                    helperTextDefault=" "
                />
                <FormField
                    name='Camera Model'
                    value={camera}
                    updateParentStateRecord={setCamera}
                    label='Camera Model'
                    fontSize='10px'
                    units=''
                    type='select'
                    selectTypeVariant='camera'
                    dataSuperset={manufacturer}
                    defaultValue={camera}
                    helperTextDefault=" "
                />
                <FormField
                    name='Camera Resolution'
                    value={resolutionData}
                    updateParentStateRecord={setResolutionData}
                    label='Camera Resolution'
                    fontSize='10px'
                    units=''
                    type='select'
                    selectTypeVariant='res'
                    dataSuperset={camera}
                    defaultValue={resolutionData}
                    helperTextDefault=" "
                />
                <FormField
                    name='Resolution X'
                    updateParentStateRecord={setResolutionX}
                    groupSize={2}
                    label='Resolution X'
                    type='number'
                    fontSize='10px'
                    units='px'
                    placeholder='1920'
                    required
                    validationType='number'
                    value={resolutionX}
                    helperTextDefault=" "
                />
                <FormField
                    name='Resolution Y'
                    updateParentStateRecord={setResolutionY}
                    groupSize={2}
                    label='Resolution Y'
                    fontSize='10px'
                    type='number'
                    units='px'
                    placeholder='1080'
                    required
                    validationType='number'
                    value={resolutionY}
                    helperTextDefault=" "
                />
                <h3 style={sectionHeadingStyle}>Effective Canvas Resolution
                    <HelpTooltip 
                        text="Constrain your canvas to prevent a framing intent from being applied outside an intended area." 
                    />
                </h3>
                
                <FormField
                    name='Effective Res X'
                    updateParentStateRecord={setEffectiveX}
                    groupSize={2}
                    label='Effective Res X'
                    type='number'
                    fontSize='10px'
                    units='px'
                    placeholder='1800'
                    validationType='number'
                    value={effectiveX}
                    helperTextDefault=" "
                />
                <FormField
                    name='Effective Res Y'
                    groupSize={2}
                    value={effectiveY}
                    label='Effective Res Y'
                    type='number'
                    fontSize='10px'
                    units='px'
                    placeholder='1000'
                    updateParentStateRecord={setEffectiveY}
                    validationType='number'
                    helperTextDefault=" "
                />
                    {/* <FormField
                        name='Effective Anchor X'
                        value={effectiveAncX}
                        defaultValue={effectiveAncX}
                        updateParentStateRecord={setEffectiveAncX}
                        groupSize={3}
                        type='number'
                        label='Effective Anchor X'
                        fontSize='10px'
                        units='px'
                        placeholder=''
                        
                        dependsOn={[ resolutionX, resolutionY, effectiveX, effectiveY]}
                        validationType='anchor'
                        validateAnchorAgainst={{'a': effectiveX, 'b': resolutionX}}
                        helperTextDefault=" "
                    />
                    <FormField
                        name='Effective Anchor Y'
                        value={effectiveAncY}
                        defaultValue={effectiveAncY}
                        updateParentStateRecord={setEffectiveAncY}
                        groupSize={3}
                        type='number'
                        label='Effective Anchor Y'
                        fontSize='10px'
                        units='px'
                        placeholder=''
                        
                        validationType='anchor'
                        validateAnchorAgainst={{'a': effectiveY, 'b': resolutionY}}
                        dependsOn={[ resolutionX, resolutionY, effectiveX, effectiveY]}
                        helperTextDefault=" "
                    />
                    <FdlButton
                        onClick={chartCenterClicked}
                        text="Center"
                        endIcon={<SelectAllOutlinedIcon />}
                        style={switchStyle}
                        dependsOn={[resolutionX, resolutionY, effectiveX, effectiveY]}
                    />   */}
                    
                <h3 style={sectionHeadingStyle}>
                    Camera Details
                    <HelpTooltip 
                        text="Additional camera details." 
                    />
                </h3>  
                <FormField
                    name='Photosite X'
                    groupSize={2}
                    type='number'
                    label='Photosite X'
                    fontSize='10px'
                    units='photosites'
                    placeholder='1920'
                    validationType='number'
                    helperTextDefault=" "
                />
                <FormField
                    name='Photosite Y'
                    groupSize={2}
                    label='Photosite Y'
                    type='number'
                    fontSize='10px'
                    units='photosites'
                    placeholder='1080'
                    validationType='number'
                    helperTextDefault=" "
                />
                <FormField
                    name='Sensor Physical Dimensions X'
                    groupSize={2}
                    label='Sensor Physical Dimensions X'
                    fontSize='10px'
                    type='number'
                    units='mm'
                    placeholder='42'
                    validationType='decimal'
                    helperTextDefault=" "
                />
                <FormField
                    name='Sensor Physical Dimensions Y'
                    groupSize={2}
                    label='Sensor Physical Dimensions Y'
                    fontSize='10px'
                    type='number'
                    units='mm'
                    placeholder='68.5'
                    validationType='decimal'
                    helperTextDefault=" "
                />
                <FormField
                    name='Anamorphic Squeeze'
                    label='Anamorphic Squeeze'
                    fontSize='10px'
                    units=''
                    type='number'
                    placeholder='1.5'
                    validationType='decimal'
                    value={anamorphic}
                    updateParentStateRecord={setAnamorphic}
                    defaultValue = '1'
                    helperTextDefault=" "
                    required
                />
                
                <div style={bottomButtonContainer}>
                    <FdlButton type='submit' text="Save camera"></FdlButton>
                    <FdlButton style={finishedButtonStyle} text="Finished adding cameras" onClick={finishSection} disabled={blockReviewPage} ></FdlButton>
                </div>
                <Alert severity='error' style={formErrorTextStyle}>
                    <AlertTitle>Form submission error:</AlertTitle>
                    {formErrorText}
                </Alert>
            </Box>
        </div>
    );
};